import axios from "axios";

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5003",
});

export default Axios;
